import { Component, OnInit } from '@angular/core';
import { WordpressService } from '../services/wordpress.service';
import { NguCarousel } from '@ngu/carousel';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  public contactForm = {
    name: '',
      email: '',
      phone: '',
      company: '',
      country: '',
      city: '',
      message: ''
  };
  public showNavbar: boolean;
  public surveys: any;
  public results: any;
  public result: any;
  public news: any;
  public filterargs: string;

  private idCatResult: string;
  private idCatSurvey: string;
  private idCatNews: string;
  // private router: Router;

  public carouselOne: NguCarousel;

  constructor(private router: Router, private wordpressService: WordpressService) {

  }

  ngOnInit(): void {

    this.carouselOne = {
      grid: { xs: 1, sm: 1, md: 1, lg: 1, all: 0 },
      slide: 1,
      speed: 400,
      interval: 2000,
      point: {
        visible: true,
        pointStyles:
        `
          .ngucarouselPoint {
            list-style-type: none;
            text-align: center;
            margin: 0;
            white-space: nowrap;
            overflow: auto;
            position: absolute;
            padding: 6px;
            width: 100%;
            top: 100%;
            left: 0;
            box-sizing: border-box;
            margin-top: 3px;
          }
          .ngucarouselPoint li {
            display: inline-block;
            border-radius: 999px;
            background: rgba(255, 255, 255, 0.55);
            padding: 5px;
            margin: 0 3px;
            transition: .1s ease all;
          }
          .ngucarouselPoint li.active {
              background: white;
              width: 10px;
          }
          .ngucarousel, .ngucarousel-inner{
            height: 100%;
          }
          .ngucarousel
        `
      },
      load: 2,
      touch: true,
      loop: true,
      custom: 'banner'
    };

    this.wordpressService.getSurveys().subscribe(data => {
      const posts = JSON.parse(data._body);
      this.surveys = posts;

      this.wordpressService.getCategories().subscribe(categories => {
        const data1 = JSON.parse(categories._body);

        this.idCatResult = this.wordpressService.getIdCategories(data1, 'encuesta');
        this.idCatNews = this.wordpressService.getIdCategories(data1, 'noticias');
        this.idCatSurvey = this.wordpressService.getIdCategories(data1, 'resultado');

        this.surveys = posts.filter(post => this.filterPost(post, this.idCatSurvey));
        this.results = posts.filter(post => this.filterPost(post, this.idCatResult));
        this.news = posts.filter(post => this.filterPost(post, this.idCatNews));

        // this.surveys = posts.filter(post => {
        //   for (let x = 0; x < post.categories.length; x++) {
        //     if (post.categories[x] === this.idCatNews ) {
        //       return true;
        //     }
        //   }
        //   return false;
        // });

        // this.results = posts.filter(post => {
        //   for (let x = 0; x < post.categories.length; x++) {
        //     if (post.categories[x] === this.idCatResult ) {
        //       return true;
        //     }
        //   }
        //   return false;
        // });

        // Muestro solo el primer resultado de encuesta
        this.result = this.results[0] ? this.results[0] : '';

      });
    });
  }

  filterPost(posts, categoryId) {
    for (let x = 0; x < posts.categories.length; x++) {
      if (posts.categories[x] === categoryId) {
        return true;
      }
    }
    return false;

  }

  setFilter(filters) {
    this.filterargs = filters;
  }

  getShorText(value: string, cant: number): string {
    // return value ? value.substr(0, cant) : null;
    return this.wordpressService.getShortText(value, cant);
  }

  getImage(img: string) {
    return this.wordpressService.getImageFromRender(img);
  }
  getImageSrc(img: string) {
    return this.wordpressService.getSrcImageFromRender(img);
  }
  verEncuesta() {
    window.open(
      'https://es.surveymonkey.com/r/ZK3FHZM',
      '_blank' // <- This is what makes it open in a new window.
    );
  }
  newTab( url: string) {
    window.open(
      url,
      '_blank' // <- This is what makes it open in a new window.
    );

  }


  verDetalle(value: any) {
    this.router.navigate(['/resultado'], {
      queryParams: { id: value.id }
    });  }
}




// WEBPACK FOOTER //
// C:/Users/gdb/Documents/work/garrido-angular/garrido-front/src/app/home/home.component.ts